/**
 * ╔═══════════════════════════════════════════════════════════════╗
 * ║                                                               ║
 * ║   MetroJS - Common Pages                                     ║
 * ║   Copyright (c) 2024 Metro Digital Solutions                  ║
 * ║                                                               ║
 * ║   共通ページコンポーネントを提供するモジュール                ║
 * ║   ページ管理モジュール                                        ║
 * ║                                                               ║
 * ╚═══════════════════════════════════════════════════════════════╝
 */

export { default as Error } from "./error.js";
export { default as NotFound } from "./not-found.js";
